import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonGroup, Column, FlexBox, HelpIcon, Icon, Text, Tooltip, } from '@dixa/lib-shared-habla';
import { useCallback, useMemo } from 'react';
import { useMeasure } from 'react-use';
import { analytics } from 'app/utils/segment';
import { useScheduleContext, } from 'components/settings/components/sections/openingHours/views/schedule/schedule.context';
import styles from './listHeader.module.scss';
const buttons = [
    {
        icon: 'clock-three',
        name: 'Business hours',
        text: 'Hours',
    },
    {
        icon: 'announcement',
        name: 'Audio messages',
        text: 'Audio messages',
    },
    {
        icon: 'reply',
        name: 'Auto-replies',
        text: 'Auto-replies',
    },
];
const menuItems = ['hours', 'audioMessages', 'autoReplies'];
export const ListHeader = ({ children, headers }) => {
    const { activeView, setActiveView } = useScheduleContext();
    const [ref, { width }] = useMeasure();
    const withButtonText = useMemo(() => width > 1000, [width]);
    const handleClick = useCallback((type) => {
        analytics.businessHoursScheduleViewClicked({
            tab: activeView.tab === 'businessHours' ? 'standard' : 'exception',
            view: type,
        });
        setActiveView(Object.assign(Object.assign({}, activeView), { menu: type }));
    }, [activeView, setActiveView]);
    const activeMenuIndex = menuItems.indexOf(activeView.menu);
    const { label: activeLabel, subLabel: activeSubLabel, helpText: activeHelpText, } = headers[activeMenuIndex];
    return (_jsxs(Column.Row, Object.assign({ slottable: true, noVerticalPadding: true, noMinHeight: true, ref: ref }, { children: [_jsx(Column.Slot, Object.assign({ placement: "start" }, { children: _jsxs(FlexBox, Object.assign({ alignItems: "center", gap: "200" }, { children: [_jsx(Text.Heading, Object.assign({ variant: "heading-3" }, { children: activeLabel })), _jsx(Text.Paragraph, Object.assign({ variant: "2" }, { children: activeSubLabel })), activeHelpText && (_jsx(HelpIcon, { dark: true, title: activeLabel, text: activeHelpText }))] })) })), _jsx(Column.Slot, Object.assign({ placement: "end" }, { children: _jsxs(FlexBox, Object.assign({ alignItems: "center", gap: "200" }, { children: [children, _jsx(ButtonGroup, Object.assign({ className: styles.buttonGroup }, { children: buttons.map(({ icon, name, text }, index) => (_jsx(Button, { active: activeMenuIndex === index, className: styles.button, label: withButtonText ? text : '', styleText: false, slotStart: _jsx(Tooltip, Object.assign({ content: name, disabled: withButtonText, wrapProps: { className: styles.iconTooltip }, dark: true }, { children: _jsx(Icon, { name: icon, style: Object.assign({}, (withButtonText && { width: 32 })) }) }), name), onClick: () => handleClick(menuItems[index]), variant: "secondary" }, name))) }))] })) }))] })));
};
